import { AUTH_TOKEN } from '../../../constants'

const isLoggedIn = () => {
  try {
    return Boolean(localStorage.getItem(AUTH_TOKEN))
  } catch (e) {
    return false
  }
}

export const trackEvent = (event, props = {}) => {
  if (typeof window === 'undefined') return
  // Don't track logged-in users — analytics is only for prospects
  if (isLoggedIn()) return
  if (typeof window.plausible !== 'function') return
  window.plausible(event, { props })
}

export const trackPageView = (page) => {
  trackEvent('landing_view', { page })
}

export const trackCTA = (label, location, extra = {}) => {
  trackEvent('cta_click', { cta_label: label, cta_location: location, ...extra })
}

export const trackVerticalClick = (vertical, source = 'main_landing') => {
  trackEvent('vertical_click', { vertical, source })
}

export const trackFeatureView = (feature, group) => {
  trackEvent('feature_view', { feature, feature_group: group })
}
